import { render, staticRenderFns } from "./UpdateAvatar.vue?vue&type=template&id=90811480&scoped=true"
import script from "./UpdateAvatar.vue?vue&type=script&lang=js"
export * from "./UpdateAvatar.vue?vue&type=script&lang=js"
import style0 from "./UpdateAvatar.vue?vue&type=style&index=0&id=90811480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90811480",
  null
  
)

export default component.exports